import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Clean%20modern%20fashion%20lifestyle%20scene%20with%20sneakers%20hoodies%20and%20accessories%20artfully%20arranged%20on%20minimalist%20cream%20surface%2C%20bright%20airy%20natural%20daylight%20streaming%20from%20large%20window%2C%20soft%20warm%20neutral%20tones%2C%20editorial%20product%20photography%20with%20gentle%20shadows%2C%20clean%20composition%20with%20plenty%20of%20negative%20space%2C%20aesthetic%20lifestyle%20flatlay%20style&width=1600&height=900&seq=hero-hoobuy-2026&orientation=landscape"
        alt="HoobuySpreadsheet - Produtos da China 2026"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/25 via-black/10 to-black/30"></div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="max-w-[580px]">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/30 text-background-50 text-xs font-medium mb-6 whitespace-nowrap backdrop-blur-sm">
            Lista Atualizada 2026
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-light text-background-50 leading-[1.1] mb-4">
            HoobuySpreadsheet
          </h1>
          <p className="text-xl md:text-2xl font-heading font-extralight text-background-50/90 mb-2">
            Atualizado 2026
          </p>
          <p className="text-base md:text-lg text-background-50/70 mb-8 leading-relaxed max-w-[480px]">
            Descubra os melhores produtos, sneakers e streetwear diretamente de spreadsheets atualizados diariamente. A sua lista de compras da China, sempre atualizada.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              hoobuy sheet
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 border-2 border-background-50/40 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2.5 bg-background-50/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}